import { deptTagClass, statusTagClass, priorityTagClass } from "@/lib/sites";

export const Badge = ({ kind, value }) => {
  const cls = kind === "priority"
    ? `border ${priorityTagClass(value)}`
    : kind === "status"
      ? `border ${statusTagClass(value)}`
      : `border ${deptTagClass(value)}`;
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${cls}`}>
      {value}
    </span>
  );
};
